<template>
    <div :class="['payment-infos-with-slider', (isDesktop ? 'desktop' : 'mobile')]">
        <!-- <div class="payment-infos" v-html="title" /> -->

        <transition name="fade">
            <img class="slider" v-if="slider1" src="/imgs/registration/slider1.webp">
        </transition>
        <transition name="fade">
            <img class="slider" v-if="slider2" src="/imgs/registration/slider2.webp">
        </transition>
        <transition name="fade">
            <img class="slider" v-if="slider3" src="/imgs/registration/slider3.webp">
        </transition>
    </div>
</template>

<script>
export default {
    props: {
        isDesktop: {
            type: Boolean,
            required: true,
        },
        templateString: {
            type: String,
        },
    },
    data() {
        return {
            interval: null,
            slider1: true,
            slider2: false,
            slider3: false,
        };
    },
    computed: {
        // title() {
        //     let title = this.$t('registration.subscription-infos-title');

        //     if (!this.templateString) {
        //         return title;
        //     }

        //     const template = JSON.parse(this.templateString);

        //     if (!template.subtitle || !template.subtitle[this.$i18n.locale()]) {
        //         return title;
        //     }

        //     return `<p>${template.subtitle[this.$i18n.locale()]}</p>`;
        // },
    },
    mounted() {
        this.startInterval();
    },
    beforeDestroy() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    },
    methods: {
        startInterval() {
            this.interval = setInterval(() => {
                if (this.slider1) {
                    this.slider1 = false;
                    this.slider2 = true;
                } else if (this.slider2) {
                    this.slider2 = false;
                    this.slider3 = true;
                } else if (this.slider3) {
                    this.slider3 = false;
                    this.slider1 = true;
                }
            }, 4000);
        },
    },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/registration/Profile/slider.vue